import { Card, Flex } from '@opendoor/bricks/core';
import ContentCard from '@opendoor/bricks/deprecated/UNSAFE_layout/ContentCard';

import trackEvent from '../helpers/trackEvent';
import { ContentWrapper } from './ContentWrapper';
import DownloadLink from './DownloadLink';

const HOMEBUILDER_ONEPAGER_HREF = 'https://odfil.es/static/Customer-facing%20HB%20flyer.PDF';
const HOMEBUILDER_HANDBOOK =
  'https://odfil.es/958c61415233627b0743876f2a6a3fdd339f617b/static/Homebuilder_Handbook_v12-2020_Generic.pdf';
const BEST_OFFER_GUARANTEE_FLYER =
  'https://odfil.es/958c61415233627b0743876f2a6a3fdd339f617b/static/2021_BestOfferGuarantee_8.5x5.5.pdf';
const AGENT_EDUCATIONAL_ONEPAGER =
  'https://odfil.es/958c61415233627b0743876f2a6a3fdd339f617b/static/Agent-facing%20HB%20flyer.pdf';

const DocumentsSection = () => {
  const trackDownload = (label: string) => () => {
    trackEvent('download', label, {});
  };

  return (
    <ContentWrapper>
      <ContentCard title="Documents" borderRadius="roundedSquare">
        <Flex flexDirection="column">
          <Card
            border="1px solid"
            borderColor="neutrals40"
            borderRadius="squared"
            width="100%"
            pl={5}
            mb={5}
          >
            <DownloadLink
              href={HOMEBUILDER_HANDBOOK}
              onClick={trackDownload('homebuilder-handbook')}
            >
              Download Your Homebuilder Handbook (PDF)
            </DownloadLink>
          </Card>
          <Card
            border="1px solid"
            borderColor="neutrals40"
            borderRadius="squared"
            width="100%"
            pl={5}
            mb={5}
          >
            <DownloadLink
              href={HOMEBUILDER_ONEPAGER_HREF}
              onClick={trackDownload('marketing-material')}
            >
              Download Homebuilder One Pager Marketing Material (PDF)
            </DownloadLink>
          </Card>
          <Card
            border="1px solid"
            borderColor="neutrals40"
            borderRadius="squared"
            width="100%"
            pl={5}
            mb={5}
          >
            <DownloadLink
              href={BEST_OFFER_GUARANTEE_FLYER}
              onClick={trackDownload('best-offer-guarantee-flyer')}
            >
              Download Best Offer Guarantee Flyer
            </DownloadLink>
          </Card>
          <Card
            border="1px solid"
            borderColor="neutrals40"
            borderRadius="squared"
            width="100%"
            pl={5}
          >
            <DownloadLink
              href={AGENT_EDUCATIONAL_ONEPAGER}
              onClick={trackDownload('agent-educational-onepager')}
            >
              Download Agent Educational One Pager (PDF)
            </DownloadLink>
          </Card>
        </Flex>
      </ContentCard>
    </ContentWrapper>
  );
};

export default DocumentsSection;
